<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="dialog-title-icon">push_pin</mat-icon>
  Select Target Facility
</h2>

<mat-dialog-content class="dialog-content">
  <app-patients-actions-facility
    [facilities]="data.facilities"
    [selectedFacility]="data.selectedFacility"
    (facilitySelected)="onFacilitySelected($event)">
  </app-patients-actions-facility>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
